import { resetLocationData, fetchRequest, updateModal, updateIsApiLoading, resetLocationDataOnly, setLocationData, deleteImageRequest, uploadImageRequest } from '../../../store/actions/location';
import { uploadImageEndPoint } from '../../../configuration';

const uploadImageAPI = async (query) => {
  try {
    const response = await fetch(uploadImageEndPoint(), {
      method: "POST",
      headers: {
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "Content-Type": "application/octet-stream",
      },
      body: query, // query is FormData containing the binary image file
    });

    if (!response.ok) new Error("API error");
    return response.json();
  } catch (error) {
    console.log(error);
  }
};

async function handleReuploadForClone(location_data, dispatch) {
    if(location_data?.cloneAction){
        const floors = Object.values(location_data?.floors || {});
        const reuploadFloors = await reuploadFloorImages(floors, dispatch);
        const updated_loc_data = {...location_data};
        if(!reuploadFloors){
            return false;
        }
        for(const floor of reuploadFloors){
            updated_loc_data.floors[floor.id] = floor;
        }
        return updated_loc_data;
    }
}

async function reuploadFloorImages(floors, dispatch) {
  try {
    const updatedFloors = [];
    for (const floor of floors) {
      let updatedFloor = { ...floor };
      if (floor?.file) {
        const response = await uploadImageAPI( floor.file );
        if (response && response.id) {
          updatedFloor.floorImageId = response.id;
        } else {
          return false;
        }
      }
      updatedFloors.push(updatedFloor);
    }
    return updatedFloors;
  } catch (error) {
    console.error("Error in reuploadFloorImages:", error);
    return false;
  }
}

const deleteImages = (dispatch, location_data) => {
    const imageIds = location_data?.imageIdsForDelete;
    if (Array.isArray(imageIds) && imageIds.length > 0) {
      (async () => {
        for (const imageId of imageIds) {
          try {
             dispatch(deleteImageRequest({ imageId : imageId }));
          } catch (err) {
            console.error(`Failed to delete image with ID: ${imageId}`, err);
          }
        }
        dispatch(setLocationData({
          ...location_data,
          imageIdsForDelete: [],
        }));
      })();
    }
};

export const handleSubmit = async (location_data, dispatch, resetLocationData, createLocation, setNotificationProps, setShowNotification) => {
    const temp_location_data = location_data;
    if(location_data?.cloneAction){
        dispatch(updateIsApiLoading(true));
        const updated_loc_data = await handleReuploadForClone(location_data, dispatch);
        if(updated_loc_data){
            temp_location_data.floors = updated_loc_data.floors;
        }else{
            setNotificationProps({
                type: 'error',
                message: 'Clone location',
                description: "Location created failed during floor creation",
                duration: 1,
                // style: { backgroundColor: '#FFECE0', color: '#155724' },
            });
            setShowNotification(true);
            setTimeout(() => {
                setShowNotification(false);
            }, 1000);
            dispatch(updateIsApiLoading(false));
            return;
        }
    }

    const { name, addfloormap, address, adjustgeofencemap, floors, lat_value, long_value, radius, id } = temp_location_data;
    const bodyData = { name, address, addfloormap, lat_value, long_value, radius, floors, adjustGeofenceMap: adjustgeofencemap, createtype: 'inventory_location', id };
    dispatch(updateIsApiLoading(true));
    try {
        const response = await createLocation(bodyData);
        if (Array.isArray(response) && response?.length > 0 && response[0]?.id) {
            deleteImages(dispatch, temp_location_data);
            setNotificationProps({
                type: 'success',
                message: 'Add location',
                description: `Location "${response[0]?.name || response?.tags[0]?.name}" created successfully`,
                duration: 1,
                style: { backgroundColor: '#d4edda', color: '#155724' },
            });
            setShowNotification(true);
            setTimeout(() => {
                setShowNotification(false);
            }, 1000);
        } else if (response instanceof Object && !response?.error) {
            deleteImages(dispatch, temp_location_data);
            setNotificationProps({
                type: 'success',
                message: 'Edit location',
                description: `Location "${response?.name || ''}" updated successfully`,
                duration: 1,
                style: { backgroundColor: '#d4edda', color: '#155724' },
            });
            setShowNotification(true);
            setTimeout(() => {
                setShowNotification(false);
            }, 1000);
        } else {
            setNotificationProps({
                type: 'error',
                message: 'Add location',
                description: "Location created failed",
                duration: 1,
                style: { backgroundColor: '#FFECE0', color: '#155724' },
            });
            setShowNotification(true);
            setTimeout(() => {
                setShowNotification(false);
            }, 1000);
        }
    } catch (error) {
        setNotificationProps({
            type: 'error',
            message: 'Add location',
            description: "Location created failed",
            duration: 1,
            style: { backgroundColor: '#FFECE0', color: '#155724' },
        });
        setShowNotification(true);
        setTimeout(() => {
            setShowNotification(false);
        }, 1000);
        dispatch(updateIsApiLoading(false));
        dispatch(resetLocationData());
    }
    setTimeout(() => {
        dispatch(updateIsApiLoading(false));
        dispatch(resetLocationData());
        dispatch(fetchRequest(10));
    }, 1500);
};

export const handleClosePopup = ({ dispatch }) => {
    // Add any cleanup logic here if needed in the future
    dispatch(resetLocationData());
    dispatch(updateModal({ current_modal: '' }));
};

export const handleClosePopupShipment = ({ closePopup = () => { }, dispatch }) => {
    // Add any cleanup logic here if needed in the future
    dispatch(resetLocationData());
    dispatch(updateModal({ current_modal: '' }));
    closePopup(false);
};